module.exports = __webpack_public_path__ + "static/media/5.485fb4c1.png";